import { render, staticRenderFns } from "./projectStepThree.vue?vue&type=template&id=064c04f4&scoped=true"
import script from "./projectStepThree.vue?vue&type=script&lang=js"
export * from "./projectStepThree.vue?vue&type=script&lang=js"
import style0 from "./projectStepThree.vue?vue&type=style&index=0&id=064c04f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064c04f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Maintenance projects\\devConfig-web-project\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('064c04f4')) {
      api.createRecord('064c04f4', component.options)
    } else {
      api.reload('064c04f4', component.options)
    }
    module.hot.accept("./projectStepThree.vue?vue&type=template&id=064c04f4&scoped=true", function () {
      api.rerender('064c04f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectConfig/components/projectStepThree.vue"
export default component.exports